import React, { useState, useEffect } from "react";
import "./DayDetail.css";

export default function DayDetails({ dayData, onSave, onClose, readOnly = false }) {
  const [form, setForm] = useState(dayData || {});

  useEffect(() => {
    setForm(dayData || {});
  }, [dayData]);

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    if (!readOnly) {
      onSave(form);
    }
  };

  const handleClose = () => {
    onClose();
  };

  if (!dayData) return null;

  const renderField = (label, field, type = "select", options = []) => (
    <div className="form-section">
      <label>{label}</label>
      {readOnly ? (
        <p className="readonly">{form[field] || "—"}</p>
      ) : type === "input" ? (
        <input
          type="text"
          value={form[field] || ""}
          placeholder={label}
          onChange={(e) => updateField(field, e.target.value)}
        />
      ) : (
        <select
          value={form[field] || ""}
          onChange={(e) => updateField(field, e.target.value)}
        >
          <option value="">— منتخب کریں —</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      )}
    </div>
  );

  return (
    <div className="day-details">
      <h2 id="day-detail-title">📖 دن {form.day} کی تفصیل</h2>

      {renderField("حاضری", "attendance", "select", ["وقت پر آئے", "نہیں آئے"])}
      {renderField("سبق", "sabaq", "select", ["بہت اچھا", "کچا پکا", "یاد نہیں"])}
      {renderField("سبقی", "sabqi", "select", ["بہت اچھا", "کچا پکا", "یاد نہیں"])}
      {renderField("منزل", "manzil", "select", ["بہت اچھا", "کچا پکا", "یاد نہیں"])}
      {renderField("نیا سبق", "newLessonStart", "input")}
      {renderField("مطالعہ پچھلے پاروں کا", "mutala", "select", ["کیا ہے", "نہیں کیا ہے"])}
      {renderField("لباس", "libaas", "select", ["مناسب", "مناسب نہیں ہے"])}

      {/* نماز */}
      <div className="form-section">
        <label>نماز</label>
        <div className="prayers">
          {["فجر", "ظہر", "عصر", "مغرب", "عشاء"].map((namaz) => (
            <div key={namaz} className="prayer-input">
              <span>{namaz}:</span>
              {readOnly ? (
                <span>{form.namaz?.[namaz] ? "✅" : "❌"}</span>
              ) : (
                <input
                  type="checkbox"
                  checked={form.namaz?.[namaz] || false}
                  onChange={(e) =>
                    updateField("namaz", {
                      ...form.namaz,
                      [namaz]: e.target.checked,
                    })
                  }
                />
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="form-actions">
        {!readOnly && (
          <button className="btn-save" onClick={handleSave}>
            💾 محفوظ کریں
          </button>
        )}
        <button className="btn-close" onClick={handleClose}>
          ❌ بند کریں
        </button>
      </div>
    </div>
  );
}
